import { withDisplayName } from '@hocs/with-display-name'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulBlogTagLabel: Utils.EntryFC<
  Queries.ContentfulBlogTagLabelFragment
> = ({ content: { tagName }, entryInspectorProps, fieldInspectorProps }) => (
  <span
    className="text-075 font-medium uppercase"
    {...entryInspectorProps()}
    {...fieldInspectorProps({
      fieldId: 'tagName',
    })}
  >
    {tagName}
  </span>
)

export const query = graphql`
  fragment ContentfulBlogTagLabel on ContentfulBlogTag {
    ...ContentfulEntry
    tagName
  }
`

export default withDisplayName(ContentfulBlogTagLabel, 'ContentfulBlogTagLabel')
